// Module
var code = "<div>\n    <pl-listing pl-id=\"bike-list\" pl-smooth-rendering=\"true\" pl-smooth-rendering-max-iterations=\"34\" pl-data-items=\"bike in bl.search()\" pl-type=\"grid\">\n        <div ng-transclude></div>\n    </pl-listing>\n</div>\n";
// Exports
var _module_exports = code;;
var path = 'components/bike/list/base/bike-list.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;